export function trapFocus(slideout_id, is_initial_open) {
  var idString = `#${slideout_id}`;
  var menu = document.getElementById(slideout_id);
  var inputs = menu.querySelectorAll(`${idString} input:not([type=hidden]), ${idString} button:not([tabindex="-1"]), ${idString} a:not([tabindex="-1"]), ${idString} textarea`);
  var firstInput;
  var lastInput;

  if (inputs[0].tagName == 'A') {
    firstInput = /** @type {HTMLAnchorElement} */ (inputs[0]);
  } else if (inputs[0].tagName == 'BUTTON') {
    firstInput = /** @type {HTMLButtonElement} */ (inputs[0]);
  }

  if (inputs[0].tagName == 'A') {
    lastInput = /** @type {HTMLAnchorElement} */ (inputs[inputs.length - 1]);
  } else if (inputs[0].tagName == 'BUTTON') {
    lastInput = /** @type {HTMLButtonElement} */ (inputs[inputs.length - 1]);
  }

  if (is_initial_open) firstInput.focus();

  // Redirect last tab to first input
  lastInput.addEventListener('keydown', function (/** @type {KeyboardEvent} */ e) {
    if (e.code === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstInput.focus();
    }
  });

  // Redirect first shift+tab to last input
  firstInput.addEventListener('keydown', function (/** @type {KeyboardEvent} */ e) {
    if (e.code === 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastInput.focus();
    }
  });
}
